import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IClaimEnglishIqV1Request } from './claim-english-iq-v1-request';
import type { IClaimEnglishIqV1Response } from './claim-english-iq-v1-response';
import { claimEnglishIqV1ResponseSchema } from './claim-english-iq-v1-response';

export async function claimEnglishIqV1Api(
  body: IClaimEnglishIqV1Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IClaimEnglishIqV1Response>> {
  return postRequest<IClaimEnglishIqV1Response>({
    body,
    options,
    path: '/english-iq/claim/v1',
    schema: claimEnglishIqV1ResponseSchema,
  });
}
